module.exports = __webpack_public_path__ + "img/product2.ffb794a1.png";